<template>
  <div v-loading="isLoading || isSaving" class="page cashback-page">
    <div class="cashback-page__title" :class="{ 'locale-usa': locale === 'USA' }">
      <Title v-if="locale !== 'USA'" :text="$t('cashback_page.reward_fee')" />
    </div>
    <FinanceTabs />
    <div v-if="activeAccount">
      <div class="cashback-page__tabs">
        <div
          v-if="
            activeAccount?.visible_services?.vkads ||
            (role === 'partner' && activeAccount?.services?.includes('vkads'))
          "
          class="cashback-page__tabs-tab"
          :class="{ active: chosenPlatform === 'vkads', 'locale-usa': locale === 'USA' }"
          @click="changeActivePlatform('vkads')"
        >
          <img src="../assets/icons/icon-vkreklama.svg" alt="" />
          <span>{{ locale === 'RU' ? 'VK Реклама' : 'VK Ads' }}</span>
        </div>
        <!-- myTarget и ВКонтакте скрыты: площадки больше не работают -->
        <div
          v-if="
            (activeAccount?.visible_services?.vkadblogger ||
              (role === 'partner' && activeAccount?.services?.includes('vkadblogger'))) &&
            locale === 'RU'
          "
          class="cashback-page__tabs-tab"
          :class="{ active: chosenPlatform === 'vkadblogger', 'locale-usa': locale === 'USA' }"
          @click="changeActivePlatform('vkadblogger')"
        >
          <img src="../assets/icons/icon-vkadblogger.svg" alt="" />
          <span>{{ locale === 'RU' ? 'VK AdBlogger' : 'VK AdBlogger' }}</span>
        </div>
        <div
          v-if="
            activeAccount?.visible_services?.yandex ||
            (role === 'partner' && activeAccount?.services?.includes('yandex'))
          "
          class="cashback-page__tabs-tab"
          :class="{ active: chosenPlatform === 'yandex', 'locale-usa': locale === 'USA' }"
          @click="changeActivePlatform('yandex')"
        >
          <img src="../assets/icons/yandex-direct-icon.svg" alt="" />
          <span>{{ locale === 'RU' ? 'Яндекс Директ' : 'Yandex.Direct' }}</span>
        </div>
        <div
          v-if="
            activeAccount?.visible_services?.promopages ||
            (role === 'partner' && activeAccount?.services?.includes('promopages'))
          "
          class="cashback-page__tabs-tab"
          :class="{ active: chosenPlatform === 'promopages', 'locale-usa': locale === 'USA' }"
          @click="changeActivePlatform('promopages')"
        >
          <img src="../assets/icons/icon-promo-page.jpeg" alt="" />
          <span>{{ locale === 'RU' ? 'Яндекс ПромоСтраница' : 'Yandex PromoPage' }}</span>
        </div>
        <div
          v-if="
            activeAccount?.visible_services?.yandexbusiness ||
            (role === 'partner' && activeAccount?.services?.includes('yandexbusiness'))
          "
          class="cashback-page__tabs-tab"
          :class="{ active: chosenPlatform === 'yandexbusiness', 'locale-usa': locale === 'USA' }"
          @click="changeActivePlatform('yandexbusiness')"
        >
          <img src="../assets/icons/icon-yandex-business.png" alt="" />
          <span>{{ locale === 'RU' ? 'Яндекс Бизнес' : 'Yandex.Business' }}</span>
        </div>
        <div
          v-if="
            activeAccount?.visible_services?.google ||
            (role === 'partner' && activeAccount?.services?.includes('google'))
          "
          class="cashback-page__tabs-tab"
          :class="{ active: chosenPlatform === 'google', 'locale-usa': locale === 'USA' }"
          @click="changeActivePlatform('google')"
        >
          <img src="../assets/icons/icon-google.svg" alt="" />
          <span>{{ locale === 'RU' ? 'Google Ads' : 'Google Ads' }}</span>
        </div>
        <div
          v-if="
            activeAccount?.visible_services?.facebook ||
            (role === 'partner' && activeAccount?.services?.includes('facebook'))
          "
          class="cashback-page__tabs-tab"
          :class="{ active: chosenPlatform === 'facebook', 'locale-usa': locale === 'USA' }"
          @click="changeActivePlatform('facebook')"
        >
          <img src="../assets/icons/icon-meta.svg" alt="" />
          <span>{{ locale === 'RU' ? 'Meta' : 'Meta' }}</span>
        </div>
        <div
          v-if="
            activeAccount?.visible_services?.tiktok ||
            (role === 'partner' && activeAccount?.services?.includes('tiktok'))
          "
          class="cashback-page__tabs-tab"
          :class="{ active: chosenPlatform === 'tiktok', 'locale-usa': locale === 'USA' }"
          @click="changeActivePlatform('tiktok')"
        >
          <img src="../assets/icons/icon-tiktok.svg" alt="" />
          <span>{{ locale === 'RU' ? 'Tiktok' : 'Tiktok' }}</span>
        </div>
        <div
          v-if="
            (activeAccount?.visible_services?.telegram ||
              (role === 'partner' && activeAccount?.services?.includes('telegram'))) &&
            !(locale === 'USA' && !activeAccount.is_legal)
          "
          class="cashback-page__tabs-tab"
          :class="{ active: chosenPlatform === 'telegram', 'locale-usa': locale === 'USA' }"
          @click="changeActivePlatform('telegram')"
        >
          <img src="../assets/icons/icon-telegram.svg" alt="" />
          <span>{{ locale === 'RU' ? 'Telegram' : 'Telegram' }}</span>
        </div>
        <div
          v-if="
            (activeAccount?.visible_services?.avito ||
              (role === 'partner' && activeAccount?.services?.includes('avito'))) &&
            locale === 'RU'
          "
          class="cashback-page__tabs-tab"
          :class="{ active: chosenPlatform === 'avito', 'locale-usa': locale === 'USA' }"
          @click="changeActivePlatform('avito')"
        >
          <img src="../assets/icons/icon-avito.svg" alt="" />
          <span>{{ locale === 'RU' ? 'Avito' : 'Avito' }}</span>
        </div>
        <div
          v-if="
            (activeAccount?.visible_services?.ozon ||
              (role === 'partner' && activeAccount?.services?.includes('ozon'))) &&
            locale === 'RU'
          "
          class="cashback-page__tabs-tab"
          :class="{ active: chosenPlatform === 'ozon', 'locale-usa': locale === 'USA' }"
          @click="changeActivePlatform('ozon')"
        >
          <img src="../assets/icons/icon-ozon.svg" alt="" />
          <span>{{ locale === 'RU' ? 'Ozon' : 'Ozon' }}</span>
        </div>
        <div
          v-if="
            (activeAccount?.visible_services?.vkmarket ||
              (role === 'partner' && activeAccount?.services?.includes('vkmarket'))) &&
            locale === 'RU'
          "
          class="cashback-page__tabs-tab"
          :class="{ active: chosenPlatform === 'vkmarket', 'locale-usa': locale === 'USA' }"
          @click="changeActivePlatform('vkmarket')"
        >
          <img src="../assets/icons/icon-vk-market.svg" alt="" />
          <span>{{ locale === 'RU' ? 'VK Маркет' : 'VK Market' }}</span>
        </div>
        <div
          v-if="
            (activeAccount?.visible_services?.metricapro ||
              (role === 'partner' && activeAccount?.services?.includes('metricapro'))) &&
            locale === 'RU'
          "
          class="cashback-page__tabs-tab"
          :class="{ active: chosenPlatform === 'metricapro', 'locale-usa': locale === 'USA' }"
          @click="changeActivePlatform('metricapro')"
        >
          <img src="../assets/icons/icon-metrika-pro.svg" alt="" />
          <span>{{ locale === 'RU' ? 'Метрика Про' : 'Metrika Pro' }}</span>
        </div>
        <div
          v-if="
            (activeAccount?.visible_services?.mediaplatform ||
              (role === 'partner' && activeAccount?.services?.includes('mediaplatform'))) &&
            locale === 'RU'
          "
          class="cashback-page__tabs-tab"
          :class="{ active: chosenPlatform === 'mediaplatform', 'locale-usa': locale === 'USA' }"
          @click="changeActivePlatform('mediaplatform')"
        >
          <img src="../assets/icons/icon-media.png" alt="" />
          <span>{{ locale === 'RU' ? 'Медиаплощадки' : 'Media Platforms' }}</span>
        </div>
        <div
          v-if="
            (activeAccount?.visible_services?.urbanads ||
              (role === 'partner' && activeAccount?.services?.includes('urbanads'))) &&
            locale === 'RU'
          "
          class="cashback-page__tabs-tab"
          :class="{ active: chosenPlatform === 'urbanads', 'locale-usa': locale === 'USA' }"
          @click="changeActivePlatform('urbanads')"
        >
          <img src="../assets/icons/icon-urban-ads.png" alt="" />
          <span>UrbanAds</span>
        </div>
      </div>
      <div
        class="cashback-page__content"
        :class="{ 'cashback-page__content--editing': editableAdvertising }"
      >
        <CashbackCart
          :key="`yandex-${componentKey}`"
          v-show="chosenPlatform === 'yandex'"
          :title="$t('cashback_cart_props.title[0]')"
          :description="$t('cashback_cart_props.description[0]')"
          :balance="
            activeAccount?.services ? activeAccount?.services?.yandex?.precalc?.cashback : null
          "
          :conditions="cashback.advertising.yandex"
          :editable="editableAdvertising"
          type="advertising"
          platform="yandex"
          @change="changeConditions"
        />
        <CashbackCart
          :key="`yandexbusiness-${componentKey}`"
          v-show="chosenPlatform === 'yandexbusiness'"
          :title="$t('cashback_cart_props.title[0]')"
          :description="$t('cashback_cart_props.description[0]')"
          :balance="
            activeAccount?.services
              ? activeAccount?.services?.yandexbusiness?.precalc?.cashback
              : null
          "
          :conditions="cashback.advertising.yandexbusiness"
          :editable="editableAdvertising"
          type="advertising"
          platform="yandexbusiness"
          @change="changeConditions"
        />
        <CashbackCart
          :key="`vkadblogger-${componentKey}`"
          v-show="chosenPlatform === 'vkadblogger'"
          :title="$t('cashback_cart_props.title[0]')"
          :description="$t('cashback_cart_props.description[0]')"
          :balance="
            activeAccount?.services ? activeAccount?.services?.vkadblogger?.precalc?.cashback : null
          "
          :conditions="cashback.advertising.vkadblogger"
          :editable="editableAdvertising"
          type="advertising"
          platform="vkadblogger"
          @change="changeConditions"
        />
        <CashbackCart
          :key="`vkads-${componentKey}`"
          v-show="chosenPlatform === 'vkads'"
          :title="$t('cashback_cart_props.title[0]')"
          :description="$t('cashback_cart_props.description_quarterly')"
          :balance="
            activeAccount?.services ? activeAccount?.services?.vkads?.precalc?.cashback : null
          "
          :conditions="cashback.advertising.vkads"
          :editable="editableAdvertising"
          type="advertising"
          platform="vkads"
          @change="changeConditions"
        />
        <CashbackCart
          :key="`google-${componentKey}`"
          v-show="chosenPlatform === 'google'"
          :title="$t('cashback_cart_props.title[0]')"
          :description="$t('cashback_cart_props.description[0]')"
          :balance="
            activeAccount?.services ? activeAccount?.services?.google?.precalc?.cashback : null
          "
          :conditions="cashback.advertising.google"
          :editable="editableAdvertising"
          type="advertising"
          platform="google"
          @change="changeConditions"
        />
        <CashbackCart
          :key="`facebook-${componentKey}`"
          v-show="chosenPlatform === 'facebook'"
          :title="$t('cashback_cart_props.title[0]')"
          :description="$t('cashback_cart_props.description[0]')"
          :balance="
            activeAccount.current_month_cashback
              ? activeAccount?.current_month_cashback?.for_advertising
              : 0
          "
          :conditions="cashback.advertising.facebook"
          :editable="editableAdvertising"
          type="advertising"
          platform="facebook"
          @change="changeConditions"
        />
        <CashbackCart
          :key="`tiktok-${componentKey}`"
          v-show="chosenPlatform === 'tiktok'"
          :title="$t('cashback_cart_props.title[0]')"
          :description="$t('cashback_cart_props.description[0]')"
          :balance="
            activeAccount?.services ? activeAccount?.services?.tiktok?.precalc?.cashback : null
          "
          :conditions="cashback.advertising.tiktok"
          :editable="editableAdvertising"
          type="advertising"
          platform="tiktok"
          @change="changeConditions"
        />
        <CashbackCart
          :key="`telegram-${componentKey}`"
          v-show="chosenPlatform === 'telegram'"
          :title="$t('cashback_cart_props.title[0]')"
          :description="$t('cashback_cart_props.description[0]')"
          :balance="
            activeAccount?.services ? activeAccount?.services?.telegram?.precalc?.cashback : null
          "
          :conditions="cashback.advertising.telegram"
          :editable="editableAdvertising"
          type="advertising"
          platform="telegram"
          @change="changeConditions"
        />
        <CashbackCart
          :key="`promopages-${componentKey}`"
          v-show="chosenPlatform === 'promopages'"
          :title="$t('cashback_cart_props.title[0]')"
          :description="$t('cashback_cart_props.description[0]')"
          :balance="
            activeAccount?.services ? activeAccount?.services?.promopages?.precalc?.cashback : null
          "
          :conditions="cashback.advertising.promopages"
          :editable="editableAdvertising"
          type="advertising"
          platform="promopages"
          @change="changeConditions"
        />
        <CashbackCart
          :key="`avito-${componentKey}`"
          v-show="chosenPlatform === 'avito'"
          :title="$t('cashback_cart_props.title[0]')"
          :description="$t('cashback_cart_props.description[0]')"
          :balance="
            activeAccount?.services ? activeAccount?.services?.avito?.precalc?.cashback : null
          "
          :conditions="cashback.advertising.avito"
          :editable="editableAdvertising"
          type="advertising"
          platform="avito"
          @change="changeConditions"
        />
        <CashbackCart
          :key="`ozon-${componentKey}`"
          v-show="chosenPlatform === 'ozon'"
          :title="$t('cashback_cart_props.title[0]')"
          :description="$t('cashback_cart_props.description[0]')"
          :balance="
            activeAccount?.services ? activeAccount?.services?.ozon?.precalc?.cashback : null
          "
          :conditions="cashback.advertising.ozon"
          :editable="editableAdvertising"
          type="advertising"
          platform="ozon"
          @change="changeConditions"
        />
        <CashbackCart
          :key="`vkmarket-${componentKey}`"
          v-show="chosenPlatform === 'vkmarket'"
          :title="$t('cashback_cart_props.title[0]')"
          :description="$t('cashback_cart_props.description[0]')"
          :balance="
            activeAccount?.services ? activeAccount?.services?.vkmarket?.precalc?.cashback : null
          "
          :conditions="cashback.advertising.vkmarket"
          :editable="editableAdvertising"
          type="advertising"
          platform="vkmarket"
          @change="changeConditions"
        />
        <CashbackCart
          :key="`metricapro-${componentKey}`"
          v-show="chosenPlatform === 'metricapro'"
          :title="$t('cashback_cart_props.title[0]')"
          :description="$t('cashback_cart_props.description[0]')"
          :balance="
            activeAccount?.services ? activeAccount?.services?.metricapro?.precalc?.cashback : null
          "
          :conditions="cashback.advertising.metricapro"
          :editable="editableAdvertising"
          type="advertising"
          platform="metricapro"
          @change="changeConditions"
        />
        <CashbackCart
          :key="`mediaplatform-${componentKey}`"
          v-show="chosenPlatform === 'mediaplatform'"
          :title="$t('cashback_cart_props.title[0]')"
          :description="$t('cashback_cart_props.description[0]')"
          :balance="
            activeAccount?.services
              ? activeAccount?.services?.mediaplatform?.precalc?.cashback
              : null
          "
          :conditions="cashback.advertising.mediaplatform"
          :editable="editableAdvertising"
          type="advertising"
          platform="mediaplatform"
          @change="changeConditions"
        />
        <CashbackCart
          :key="`urbanads-${componentKey}`"
          v-show="chosenPlatform === 'urbanads'"
          :title="$t('cashback_cart_props.title[0]')"
          :description="$t('cashback_cart_props.description[0]')"
          :balance="
            activeAccount?.services ? activeAccount?.services?.urbanads?.precalc?.cashback : null
          "
          :conditions="cashback.advertising.urbanads"
          :editable="editableAdvertising"
          type="advertising"
          platform="urbanads"
          @change="changeConditions"
        />
        <div
          v-if="
            (role === 'manager' || role === 'finance' || role === 'admin') && !editableAdvertising
          "
          class="cashback-page__edit"
          @click="editableAdvertising = true"
        >
          {{ $t('cashback_views.edit') }}
        </div>
        <button
          v-if="
            (role === 'manager' || role === 'finance' || role === 'admin') && editableAdvertising
          "
          @click="loadDefaultValues"
          class="cashback-page__set-default-btn btn btn-default"
          :disabled="isSaving"
          style="margin-top: 1rem"
        >
          {{ $t('cashback_cart.default_values') }}
        </button>
      </div>
      <div class="cashback-page__content cashback-page__content--red">
        <CashbackCart
          :key="`vkadblogger-commission-${componentKey}`"
          v-show="
            chosenPlatform === 'vkadblogger' && checkConditions(commissionConditions.vkadblogger)
          "
          :title="$t('cashback_cart_props.title[3]')"
          :conditions="commissionConditions.vkadblogger"
          :editable="editableCommission"
          type="commission-terms"
          platform="vkadblogger"
          @change="changeCommissionConditions"
        />
        <CashbackCart
          :key="`vkads-commission-${componentKey}`"
          v-show="chosenPlatform === 'vkads' && checkConditions(commissionConditions.vkads)"
          :title="$t('cashback_cart_props.title[3]')"
          :conditions="commissionConditions.vkads"
          :editable="editableCommission"
          type="commission-terms"
          platform="vkads"
          @change="changeCommissionConditions"
        />
        <CashbackCart
          :key="`facebook-commission-${componentKey}`"
          v-show="chosenPlatform === 'facebook' && checkConditions(commissionConditions.facebook)"
          :title="$t('cashback_cart_props.title[3]')"
          :conditions="commissionConditions.facebook"
          :editable="editableCommission"
          type="commission-terms"
          platform="facebook"
          @change="changeCommissionConditions"
        />
        <CashbackCart
          :key="`yandex-commission-${componentKey}`"
          v-show="chosenPlatform === 'yandex' && checkConditions(commissionConditions.yandex)"
          :title="$t('cashback_cart_props.title[3]')"
          :conditions="commissionConditions.yandex"
          :editable="editableCommission"
          type="commission-terms"
          platform="yandex"
          @change="changeCommissionConditions"
        />
        <CashbackCart
          :key="`promopages-commission-${componentKey}`"
          v-show="
            chosenPlatform === 'promopages' && checkConditions(commissionConditions.promopages)
          "
          :title="$t('cashback_cart_props.title[3]')"
          :conditions="commissionConditions.promopages"
          :editable="editableCommission"
          type="commission-terms"
          platform="promopages"
          @change="changeCommissionConditions"
        />
        <CashbackCart
          :key="`yandexbusiness-commission-${componentKey}`"
          v-show="
            chosenPlatform === 'yandexbusiness' &&
            checkConditions(commissionConditions.yandexbusiness)
          "
          :title="$t('cashback_cart_props.title[3]')"
          :conditions="commissionConditions.yandexbusiness"
          :editable="editableCommission"
          type="commission-terms"
          platform="yandexbusiness"
          @change="changeCommissionConditions"
        />
        <CashbackCart
          :key="`google-commission-${componentKey}`"
          v-show="chosenPlatform === 'google' && checkConditions(commissionConditions.google)"
          :title="$t('cashback_cart_props.title[3]')"
          :conditions="commissionConditions.google"
          :editable="editableCommission"
          type="commission-terms"
          platform="google"
          @change="changeCommissionConditions"
        />
        <CashbackCart
          :key="`tiktok-commission-${componentKey}`"
          v-show="chosenPlatform === 'tiktok' && checkConditions(commissionConditions.tiktok)"
          :title="$t('cashback_cart_props.title[3]')"
          :conditions="commissionConditions.tiktok"
          :editable="editableCommission"
          type="commission-terms"
          platform="tiktok"
          @change="changeCommissionConditions"
        />
        <CashbackCart
          :key="`telegram-commission-${componentKey}`"
          v-show="chosenPlatform === 'telegram' && checkConditions(commissionConditions.telegram)"
          :title="$t('cashback_cart_props.title[3]')"
          :conditions="commissionConditions.telegram"
          :editable="editableCommission"
          type="commission-terms"
          platform="telegram"
          @change="changeCommissionConditions"
        />
        <CashbackCart
          :key="`avito-commission-${componentKey}`"
          v-show="chosenPlatform === 'avito' && checkConditions(commissionConditions.avito)"
          :title="$t('cashback_cart_props.title[3]')"
          :conditions="commissionConditions.avito"
          :editable="editableCommission"
          type="commission-terms"
          platform="avito"
          @change="changeCommissionConditions"
        />
        <CashbackCart
          :key="`ozon-commission-${componentKey}`"
          v-show="chosenPlatform === 'ozon' && checkConditions(commissionConditions.ozon)"
          :title="$t('cashback_cart_props.title[3]')"
          :conditions="commissionConditions.ozon"
          :editable="editableCommission"
          type="commission-terms"
          platform="ozon"
          @change="changeCommissionConditions"
        />
        <CashbackCart
          :key="`vkmarket-commission-${componentKey}`"
          v-show="chosenPlatform === 'vkmarket' && checkConditions(commissionConditions.vkmarket)"
          :title="$t('cashback_cart_props.title[3]')"
          :conditions="commissionConditions.vkmarket"
          :editable="editableCommission"
          type="commission-terms"
          platform="vkmarket"
          @change="changeCommissionConditions"
        />
        <CashbackCart
          :key="`metricapro-commission-${componentKey}`"
          v-show="
            chosenPlatform === 'metricapro' && checkConditions(commissionConditions.metricapro)
          "
          :title="$t('cashback_cart_props.title[3]')"
          :conditions="commissionConditions.metricapro"
          :editable="editableCommission"
          type="commission-terms"
          platform="metricapro"
          @change="changeCommissionConditions"
        />
        <CashbackCart
          :key="`mediaplatform-commission-${componentKey}`"
          v-show="
            chosenPlatform === 'mediaplatform' &&
            checkConditions(commissionConditions.mediaplatform)
          "
          :title="$t('cashback_cart_props.title[3]')"
          :conditions="commissionConditions.mediaplatform"
          :editable="editableCommission"
          type="commission-terms"
          platform="mediaplatform"
          @change="changeCommissionConditions"
        />
        <CashbackCart
          :key="`urbanads-commission-${componentKey}`"
          v-show="chosenPlatform === 'urbanads' && checkConditions(commissionConditions.urbanads)"
          :title="$t('cashback_cart_props.title[3]')"
          :conditions="commissionConditions.urbanads"
          :editable="editableCommission"
          type="commission-terms"
          platform="urbanads"
          @change="changeCommissionConditions"
        />
        <div
          v-if="
            (role === 'manager' || role === 'finance' || role === 'admin') && !editableCommission
          "
          class="cashback-page__edit"
          @click="editableCommission = true"
        >
          {{ $t('cashback_views.edit') }}
        </div>
      </div>
      <div v-if="errors" class="cashback-page__errors">
        <p v-for="(error, idx) in errors" :key="idx">
          <span v-for="(err, idx2) in error" :key="idx2">
            {{ err }}
          </span>
        </p>
      </div>
      <div v-if="editableAdvertising || editableCommission" class="cashback-page__buttons">
        <button @click="saveChanges" class="btn btn-save" :disabled="isSaving">
          {{ $t('button_props.save_changes') }}
        </button>
        <button @click="cancelChanges" class="btn btn-cancel" :disabled="isSaving">
          {{ $t('button_props.cancel') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Title from '../components/elements/Title';
import CashbackCart from '../components/cashback/CashbackCart';
import checkCashback from '@/mixin/checkCashback';
import FinanceTabs from '@/components/blocks/FinanceTabs';

export default {
  name: 'Cashback',
  components: { CashbackCart, Title, FinanceTabs },
  mixins: [checkCashback],
  data() {
    return {
      isLoading: true,
      locale: process.env.VUE_APP_LOCALE,
      lang: this.$i18n._vm.locale,
      editable: false,
      editableAdvertising: false,
      editableCommission: false,
      chosenPlatform: '',
      totalConditions: null,
      totalCommissionConditions: null,
      errors: null,
      cashbackSettings: null,
      defaultCashbackConditions: null,
      defaultCommissionConditions: null,
      componentKey: 0,
      isSaving: false,
    };
  },
  computed: {
    getLang() {
      let language = this.$i18n._vm.locale;
      return language;
    },
    activeAccount() {
      if (this.$store.state.Auth.activeAccount) {
        return this.$store.state.Auth.activeAccount;
      } else {
        return this.cashbackSettings;
      }
    },
    cashback() {
      if (this.activeAccount) {
        // Если есть totalConditions (режим редактирования), используем их
        if (this.totalConditions) {
          return this.totalConditions;
        }
        return this.activeAccount.cashback_conditions;
      }
      return {};
    },
    commissionConditions() {
      let obj = {};

      // Если есть totalCommissionConditions (режим редактирования), используем их
      if (this.totalCommissionConditions) {
        for (const key in this.totalCommissionConditions) {
          if (!Array.isArray(this.totalCommissionConditions[key])) {
            obj[key] = [{ max: null, min: 0, percent: 0 }];
          } else {
            obj[key] = this.totalCommissionConditions[key];
          }
        }
        if (!('telegram' in obj) && this.locale === 'RU') {
          obj.telegram = [{ max: null, min: 0, percent: 15 }];
        }
        if (!('promopages' in obj) && this.locale === 'RU') {
          obj.promopages = [{ max: null, min: 0, percent: 0 }];
        }
        return obj;
      }

      // Иначе используем данные из activeAccount
      if (this.activeAccount && this.activeAccount.commissions_conditions) {
        for (const key in this.activeAccount.commissions_conditions) {
          if (!Array.isArray(this.activeAccount.commissions_conditions[key])) {
            obj[key] = [{ max: null, min: 0, percent: 0 }];
          } else {
            obj[key] = this.activeAccount.commissions_conditions[key];
          }
        }
        if (!('telegram' in obj) && this.locale === 'RU') {
          obj.telegram = [{ max: null, min: 0, percent: 15 }];
        }
        if (!('promopages' in obj) && this.locale === 'RU') {
          obj.promopages = [{ max: null, min: 0, percent: 0 }];
        }
      }
      return obj;
    },
    role() {
      return this.$store.state.Auth.role;
    },
    user() {
      return this.$store.state.Auth.user;
    },
  },
  watch: {
    async activeAccount(val) {
      if (val) {
        if (val.role === 'user' && !this.сashbackSettings) {
          await this.setCashbackSettings();
        }

        this.totalConditions = JSON.parse(JSON.stringify(val.cashback_conditions));
        this.totalCommissionConditions = JSON.parse(JSON.stringify(val.commissions_conditions));
        this.setStartActiveTab();
      }
    },
    user: {
      deep: true,
      async handler(val) {
        if (val.role === 'user' && !this.сashbackSettings) {
          await this.setCashbackSettings();
        }
      },
    },
  },
  async mounted() {
    if (this.cashback) {
      this.totalConditions = JSON.parse(JSON.stringify(this.cashback));
    }
    if (this.commissionConditions) {
      this.totalCommissionConditions = JSON.parse(JSON.stringify(this.commissionConditions));
    }
    if (this.activeAccount) {
      this.setStartActiveTab();
    }

    if (this.role === 'user' && !this.сashbackSettings) {
      await this.setCashbackSettings();
    }

    // Загружаем дефолтные значения для менеджеров, финансистов и администраторов
    if (this.role === 'manager' || this.role === 'finance' || this.role === 'admin') {
      await this.loadDefaultConditions();
    }

    this.isLoading = false;
  },
  methods: {
    async setCashbackSettings() {
      const response = await this.$store.dispatch('Ad/getAdvertServices');
      this.cashbackSettings = response.data;
    },
    async loadDefaultConditions() {
      try {
        const response = await this.$store.dispatch('Ad/getAdvertServices');
        this.defaultCashbackConditions = response.data;
        this.defaultCommissionConditions = response.data;
      } catch (error) {
        console.error('Ошибка при загрузке дефолтных значений:', error);
      }
    },
    setStartActiveTab() {
      if (
        (this.activeAccount.visible_services && this.activeAccount.visible_services.google) ||
        (this.role === 'partner' && this.activeAccount?.services?.includes('google'))
      ) {
        this.chosenPlatform = 'google';
      } else if (
        (this.activeAccount.visible_services && this.activeAccount.visible_services.vkads) ||
        (this.role === 'partner' && this.activeAccount?.services?.includes('vkads'))
      ) {
        this.chosenPlatform = 'vkads';
      } else if (
        (this.activeAccount.visible_services && this.activeAccount.visible_services.facebook) ||
        (this.role === 'partner' && this.activeAccount?.services?.includes('facebook'))
      ) {
        this.chosenPlatform = 'facebook';
      } else if (
        (this.activeAccount.visible_services && this.activeAccount.visible_services.yandex) ||
        (this.role === 'partner' && this.activeAccount?.services?.includes('yandex'))
      ) {
        this.chosenPlatform = 'yandex';
      } else if (
        (this.activeAccount.visible_services && this.activeAccount.visible_services.promopages) ||
        (this.role === 'partner' && this.activeAccount?.services?.includes('promopages'))
      ) {
        this.chosenPlatform = 'promopages';
      } else if (
        (this.activeAccount.visible_services && this.activeAccount.visible_services.vkadblogger) ||
        (this.role === 'partner' && this.activeAccount?.services?.includes('vkadblogger'))
      ) {
        this.chosenPlatform = 'vkadblogger';
      } else if (
        (this.activeAccount.visible_services && this.activeAccount.visible_services.tiktok) ||
        (this.role === 'partner' && this.activeAccount?.services?.includes('tiktok'))
      ) {
        this.chosenPlatform = 'tiktok';
      } else if (
        (this.activeAccount.visible_services && this.activeAccount.visible_services.telegram) ||
        (this.role === 'partner' && this.activeAccount?.services?.includes('telegram'))
      ) {
        this.chosenPlatform = 'telegram';
      } else if (
        (this.activeAccount.visible_services &&
          this.activeAccount.visible_services.yandexbusiness) ||
        (this.role === 'partner' && this.activeAccount?.services?.includes('yandexbusiness'))
      ) {
        this.chosenPlatform = 'yandexbusiness';
      } else if (
        (this.activeAccount.visible_services && this.activeAccount.visible_services.avito) ||
        (this.role === 'partner' && this.activeAccount?.services?.includes('avito'))
      ) {
        this.chosenPlatform = 'avito';
      } else if (
        (this.activeAccount.visible_services && this.activeAccount.visible_services.ozon) ||
        (this.role === 'partner' && this.activeAccount?.services?.includes('ozon'))
      ) {
        this.chosenPlatform = 'ozon';
      } else if (
        (this.activeAccount.visible_services && this.activeAccount.visible_services.vkmarket) ||
        (this.role === 'partner' && this.activeAccount?.services?.includes('vkmarket'))
      ) {
        this.chosenPlatform = 'vkmarket';
      } else if (
        (this.activeAccount.visible_services && this.activeAccount.visible_services.metricapro) ||
        (this.role === 'partner' && this.activeAccount?.services?.includes('metricapro'))
      ) {
        this.chosenPlatform = 'metricapro';
      } else if (
        (this.activeAccount.visible_services &&
          this.activeAccount.visible_services.mediaplatform) ||
        (this.role === 'partner' && this.activeAccount?.services?.includes('mediaplatform'))
      ) {
        this.chosenPlatform = 'mediaplatform';
      } else if (
        (this.activeAccount.visible_services && this.activeAccount.visible_services.urbanads) ||
        (this.role === 'partner' && this.activeAccount?.services?.includes('urbanads'))
      ) {
        this.chosenPlatform = 'urbanads';
      }
    },

    changeConditions(data, type, platform) {
      if (type === 'deposit') {
        this.totalConditions.deposit = data;
      } else {
        if (!this.totalConditions[type]) this.totalConditions[type] = {};
        this.totalConditions[type][platform] = data;
      }
    },
    changeCommissionConditions(data, type, platform) {
      if (!this.totalCommissionConditions) this.totalCommissionConditions = [];
      this.totalCommissionConditions[platform] = data;
    },
    changeActivePlatform(platform) {
      this.chosenPlatform = platform;
    },
    cancelChanges() {
      this.errors = null;
      this.editableAdvertising = false;
      this.editableCommission = false;

      // Восстанавливаем исходные данные из activeAccount
      if (this.activeAccount) {
        this.totalConditions = JSON.parse(JSON.stringify(this.activeAccount.cashback_conditions));
        this.totalCommissionConditions = JSON.parse(
          JSON.stringify(this.activeAccount.commissions_conditions)
        );
        this.componentKey++;
      }
    },
    async saveChanges() {
      this.isSaving = true;
      this.errors = null;

      try {
        const token = localStorage.getItem('token');
        let hasChanges = false;

        // Сохраняем условия кэшбека
        if (this.totalConditions && Object.keys(this.totalConditions).length) {
          const data = {
            cashback_conditions: this.totalConditions,
            commissions_conditions: this.totalCommissionConditions,
          };
          await this.$store.dispatch('Balance/changeCashback', {
            id: this.activeAccount.id,
            data,
            token,
          });
          hasChanges = true;
        }

        // Сохраняем условия комиссий
        if (this.totalCommissionConditions && Object.keys(this.totalCommissionConditions).length) {
          const dataCommissions = {
            commissions_conditions: this.totalCommissionConditions,
          };
          await this.$store.dispatch('Balance/changeCommission', {
            id: this.activeAccount.id,
            data: dataCommissions,
            token,
          });
          hasChanges = true;
        }

        // Если были изменения, обновляем локальное состояние
        if (hasChanges) {
          // Обновляем activeAccount с новыми данными
          if (this.activeAccount) {
            this.activeAccount.cashback_conditions = JSON.parse(
              JSON.stringify(this.totalConditions)
            );
            this.activeAccount.commissions_conditions = JSON.parse(
              JSON.stringify(this.totalCommissionConditions)
            );
          }

          // Закрываем режим редактирования
          this.cancelChanges();
        }
      } catch (err) {
        if (err.data && err.data.errors) {
          this.errors = err.data.errors;
        } else {
          this.errors = ['Произошла ошибка при сохранении'];
        }
      } finally {
        this.isSaving = false;
      }
    },
    checkConditions(platform) {
      if (this.role === 'manager' || this.role === 'finance' || this.role === 'admin') {
        return true;
      } else if (platform) {
        return !!platform.find((el) => {
          return +el.percent !== 0;
        });
      }
    },
    async loadDefaultValues() {
      // Если дефолтные значения не загружены, загружаем их
      if (!this.defaultCashbackConditions) {
        await this.loadDefaultConditions();

        if (!this.defaultCashbackConditions) {
          return;
        }
      }

      // Подставляем дефолтные значения только для кэшбека за рекламу
      if (
        this.editableAdvertising &&
        this.defaultCashbackConditions &&
        this.defaultCashbackConditions.cashback_conditions &&
        this.defaultCashbackConditions.cashback_conditions.advertising &&
        this.defaultCashbackConditions.cashback_conditions.advertising[this.chosenPlatform]
      ) {
        if (!this.totalConditions) this.totalConditions = {};
        if (!this.totalConditions.advertising) this.totalConditions.advertising = {};
        this.totalConditions.advertising[this.chosenPlatform] = JSON.parse(
          JSON.stringify(
            this.defaultCashbackConditions.cashback_conditions.advertising[this.chosenPlatform]
          )
        );
        this.componentKey++;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/helpers/variables';
@import '@/assets/styles/helpers/mixin';

.cashback-page {
  &__content {
    position: relative;
  }
  &__set-default-btn {
    position: absolute;
    margin-top: 1rem;
    top: 20px;
    right: 30px;

    @include below(600px) {
      top: 90px;
      left: 16px;
    }
  }

  &__title {
    margin-bottom: 3rem;
    display: flex;
    align-items: center;
    &.locale-usa {
      margin-bottom: 3.2rem;
      .title {
        font-family: 'Gilroy';
        font-style: normal;
        font-weight: 700;
        font-size: 3.2rem;
      }
    }
  }

  &__table {
    margin-bottom: 3.2rem;

    &:last-of-type {
      margin-bottom: 0;
    }

    &-box {
      padding: 3.2rem;
      background: #fff;
      box-shadow: 0px 4px 12px rgba(192, 192, 192, 0.12);
      border-radius: 6px;
      margin-bottom: 3rem;
    }

    &-title {
      font-weight: 700;
      font-size: 2.4rem;
      line-height: 2.8rem;
      margin-bottom: 2.1rem;
    }

    &-thead {
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      color: #333333;

      & > img {
        display: block;
        height: 2rem;
        width: 2rem;
        margin-right: 0.8rem;
      }
    }

    &-percent {
      display: block;
      text-align: center;
    }
  }

  &__tabs {
    display: flex;
    margin-bottom: 1.4rem;
    flex-wrap: wrap;
    row-gap: 1rem;

    &-tab {
      height: 4.8rem;
      // max-height: 4.8rem;
      white-space: nowrap;
      // max-width: 23%;
      // width: 100%;
      border-radius: 6px;
      display: flex;
      align-items: center;
      background: rgba(214, 224, 242, 0.2);
      font-weight: 500;
      font-size: 1.6rem;
      line-height: 1.9rem;
      // padding: 0 2rem;
      opacity: 0.5;
      padding: 1.5rem 1rem;
      margin-right: 1rem;
      cursor: pointer;
      transition: 0.3s ease-out;

      &:hover {
        box-shadow: 0 5px 10px rgba(158, 158, 158, 0.1);
      }

      &.active {
        opacity: 1;
        background: #d6e0f2;
        box-shadow: 0 5px 10px rgba(158, 158, 158, 0.1);

        span {
          display: block;
        }
      }
      &.locale-usa {
        background: none;
        &.active {
          border: 2px solid var(--primary);
          background: #fff;
        }
      }

      span {
        display: none;
        margin-left: 0.8rem;
      }

      &:last-of-type {
        margin-right: 0;
      }

      & > img {
        display: block;
        height: 2.5rem;
        width: 3rem;
        // margin-right: 0.8rem;
        object-fit: contain;
      }
    }
  }

  &__editable {
    background-color: transparent;
    border: none;
    display: flex;
    align-items: center;
    font-size: 1.6rem;
    line-height: 1.9rem;
    color: var(--primary);
    margin-left: 2rem;

    img {
      margin-right: 0.5rem;
    }
  }

  &__content {
    background: #e9edf3;
    border-radius: 0.8rem;
    margin-bottom: 1.4rem;

    &--red {
      background: #ffeded;
    }
  }

  &__edit {
    color: var(--primary);
    cursor: pointer;
    margin-top: 2.5rem;
    display: inline-block;
    padding: 0 4.5rem 4.5rem 4.5rem;
  }

  &__errors {
    font-size: 1.2rem;
    color: $redLight;
  }

  &__buttons {
    display: flex;
    align-items: center;
    margin-top: 45px;
    flex-wrap: wrap;
    gap: 1rem;
  }

  .btn {
    border: 1px solid var(--primary);
    box-sizing: border-box;
    border-radius: 4px;
    height: 45px;
    padding: 0 24px;
    font-size: 16px;
    line-height: 19px;
    color: var(--primary);
    transition: 0.3s ease-out;
    box-shadow: none;

    &:hover {
      background-color: var(--primary);
      color: #fff;
    }

    &-save {
      background-color: var(--primary);
      color: #fff;

      &:hover {
        background-color: transparent;
        color: var(--primary);
      }
    }

    &-default {
      background-color: transparent;
      color: var(--primary);
      border: 1px solid var(--primary);

      &:hover {
        background-color: var(--primary);
        color: #fff;
      }
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;

      &:hover {
        background-color: transparent;
        color: var(--primary);
      }
    }
  }
}

@include below(769px) {
  .cashback-page__tabs {
    flex-wrap: wrap;
    margin-bottom: -1rem;
  }
  .cashback-page__tabs-tab {
    margin-right: 1rem;
    margin-bottom: 1rem;
    white-space: normal;
  }

  .cashback-page__content {
    margin-top: 1.4rem;
  }
}

@include below(500px) {
  .cashback-page__tabs-tab {
    font-size: 0;
    justify-content: center;
    img {
      height: 24px;
      width: auto;
    }
  }

  .cashback-page__buttons {
    flex-direction: column;
    margin-top: 2rem;

    .btn {
      min-height: 40px;
      width: 100%;
      margin-right: 0;
      margin-bottom: 1rem;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
